<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader class="d-flex align-items-center justify-content-between"
          >بانک سؤال
          <CButton
            color="primary"
            :disabled="loading"
            square
            size="sm"
            @click="addQBankModal = true"
            class="px-sm-5"
          >
            <CIcon name="cil-plus" />افزودن
          </CButton>
        </CCardHeader>
        <CCardBody class="d-flex align-items-center text-center h-100">
          <CDataTable
            class="
              w-100
              d-flex
              flex-column
              justify-content-between
              align-items-end
              h-100
            "
            :noItemsView="{
              noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
            }"
            :items="computedQBank"
            :fields="fields"
            :items-per-page="10"
            hover
            striped
            border
            small
            fixed
            pagination
            column-filter
            :loading="loading"
          >
            <!-- <template #courses="{ item }">
              <td>
                <div
                  v-for="course in item.courses"
                  :key="course.id"
                  class="course-list"
                >
                  {{ course.name }} {{ course.klass.grade.name }}
                  {{ course.klass.name }}<span class="comma">، </span>
                </div>
              </td>
            </template> -->

            <template #showQuestion="{ item }">
              <td>
                <CButton
                  :disabled="loading"
                  square
                  size="sm"
                  class="modal-button"
                  @click="onViewQBankModal(item)"
                >
                  مشاهده
                </CButton>
              </td>
            </template>
            <template #editQuestion="{ item }">
              <td>
                <CButton
                  :disabled="loading"
                  square
                  size="sm"
                  @click="onEditQBankModal(item)"
                >
                  <CIcon name="cil-pen" />
                </CButton>
              </td>
            </template>
            <template #removeQuestion="{ item }">
              <td>
                <CButton
                  :disabled="loading"
                  square
                  size="sm"
                  @click="onRemoveQBankModal(item)"
                >
                  <CIcon name="cil-trash" />
                </CButton>
              </td>
            </template>
            <template #title-filter> <span></span></template>
            <template #showQuestion-filter> <span></span></template>
            <template #editQuestion-filter> <span></span></template>
            <template #removeQuestion-filter> <span></span></template>
          </CDataTable>
          <AddQBankModal v-model="addQBankModal" @get-qbank="getQBank" />
          <ViewQBankModal v-model="viewQBankModal" :qbank="selectedItem" />
          <EditQBankModal
            v-model="editQBankModal"
            @get-qbank="getQBank"
            :qbank="selectedItem"
          />
          <RemoveQBankModal
            v-model="removeQBankModal"
            :qbank="selectedItem"
            @get-qbank="getQBank"
          />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import AddQBankModal from "@/components/Modals/QuestionBank/AddQBankModal.vue";
import ViewQBankModal from "@/components/Modals/QuestionBank/ViewQBankModal.vue";
import RemoveQBankModal from "@/components/Modals/QuestionBank/RemoveQBankModal.vue";
import EditQBankModal from "@/components/Modals/QuestionBank/EditQBankModal.vue";

export default {
  components: {
    AddQBankModal,
    ViewQBankModal,
    RemoveQBankModal,
    EditQBankModal,
  },
  name: "QuestionBank",
  data() {
    return {
      qBank: [],
      loading: false,
      fields: [
        { key: "title", label: "عنوان" },
        { key: "computedDate", label: "تاریخ" },
        { key: "courseName", label: "نام درس" },
        { key: "showQuestion", label: "نمایش" },
        { key: "editQuestion", label: "ویرایش" },
        { key: "removeQuestion", label: "حذف" },
      ],
      selectedItem: null,
      addQBankModal: false,
      viewQBankModal: false,
      editQBankModal: false,
      removeQBankModal: false,
    };
  },
  computed: {
    computedQBank() {
      return this.qBank.map((item) => {
        return {
          ...item,
          courseName: this.getCourseName(item).toString(),
          computedDate: item.addDate.replaceAll("-", "/"),
        };
      });
    },
  },
  mounted() {
    this.getQBank();
  },
  methods: {
    getCourseName(item) {
      let name = "";
      for (let i = 0; i < item.courses.length; i++) {
        name += `${item.courses[i].name} ${item.courses[i].klass.grade.name} ${item.courses[i].klass.name}`;
        if (i < item.courses.length - 1) {
          name += "، ";
        }
      }
      return name;
    },
    async getQBank() {
      try {
        this.loading = true;
        const { data } = await axios.get("/qbank");
        this.qBank = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onViewQBankModal(item) {
      this.selectedItem = item;
      this.viewQBankModal = true;
    },
    onEditQBankModal(item) {
      this.selectedItem = item;
      this.editQBankModal = true;
    },
    onRemoveQBankModal(item) {
      this.selectedItem = item;
      this.removeQBankModal = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
